import { useRef } from 'react';

import { keepPreviousData, useInfiniteQuery } from '@tanstack/react-query';

import { callGetAccounts } from '@app/store/zustand/wallet/request';

import { parseData } from './parseData';

interface UseAccountsQuery {
    pageOwnerId?: string | null;
    withCollectibles?: boolean;
}

export const USER_WALLETS_BY_USER_CACHE = 'user-accounts';

export function useAccountsItems({ pageOwnerId }: UseAccountsQuery) {
    const isFailing = useRef(false);

    const queryKey = [USER_WALLETS_BY_USER_CACHE, pageOwnerId];

    const disabled = !pageOwnerId || isFailing.current;

    const { data, ...rest } = useInfiniteQuery({
        queryKey,
        queryFn: ({ signal, pageParam }) =>
            callGetAccounts({
                variables: {
                    userFilter: { id: pageOwnerId },
                    withCollectibles: true,
                    cursorInput: {
                        limit: 100,
                        cursor: pageParam || null,
                    },
                },
                settings: { signal },
            }),
        initialPageParam: '',
        select: (response) => parseData(response),
        getNextPageParam: (response) => response?.accounts?.cursor || null,
        staleTime: Infinity,
        enabled: !disabled,
        placeholderData: keepPreviousData,
        retry: false,
    });

    isFailing.current = Boolean(rest?.isError || (!rest.isPending && !data));
    return { data, ...rest };
}
